import classNames from 'classnames';
import React from 'react';

import Style from './Label.module.scss';

interface ErrorLabelProps {
  errorMessage: any;
  className?: string;
}

const ErrorLabel: React.FC<ErrorLabelProps> = (props: ErrorLabelProps) => {
  const { errorMessage } = props;
  return <div className={classNames(Style.labelError, props.className)}>{errorMessage}</div>;
};

export default ErrorLabel;
